import React from "react";
import styles from "../Dashboard.module.css";

const LinkedMembers = () => {
  return (
    <div className={styles.dashboard}>
      <main className={styles.main}>Linked Members</main>
    </div>
  );
};

export default LinkedMembers;
